// import font
import 'typeface-tienne';

// Highlighting for code blocks
import 'prismjs/themes/prism-tomorrow.css';

// custom CSS styles
import './src/style.css';
